import React from "react";
import Article from "../../components/global/Articles/Article";
import Layout from "../../components/layout/Layout/Layout";
import Header from "../../components/layout/Header/Header";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";

export default function ArticlePage() {
  return (
    <Layout>
      <Header></Header>
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <Article />
    </Layout>
  );
}
